import { Shield, BarChart3, Target, Settings, ExternalLink } from 'lucide-react';

// Louisiana parishes for dropdown
export const LOUISIANA_PARISHES = [
  "Acadia", "Allen", "Ascension", "Assumption", "Avoyelles", "Beauregard", "Bienville",
  "Bossier", "Caddo", "Calcasieu", "Caldwell", "Cameron", "Catahoula", "Claiborne",
  "Concordia", "De Soto", "East Baton Rouge", "East Carroll", "East Feliciana", "Evangeline",
  "Franklin", "Grant", "Iberia", "Iberville", "Jackson", "Jefferson", "Jefferson Davis",
  "Lafayette", "Lafourche", "LaSalle", "Lincoln", "Livingston", "Madison", "Morehouse",
  "Natchitoches", "Orleans", "Ouachita", "Plaquemines", "Pointe Coupee", "Rapides",
  "Red River", "Richland", "Sabine", "St. Bernard", "St. Charles", "St. Helena",
  "St. James", "St. John the Baptist", "St. Landry", "St. Martin", "St. Mary", "St. Tammany",
  "Tangipahoa", "Tensas", "Terrebonne", "Union", "Vermilion", "Vernon", "Washington",
  "Webster", "West Baton Rouge", "West Carroll", "West Feliciana", "Winn"
];

export const DEFAULT_CONSENT = {
  necessary: true,
  analytics: false,
  marketing: false,
  personalization: false,
  thirdParty: false,
  consentGiven: false,
  consentDate: null,
  consentVersion: '1.0'
};

export const DEFAULT_LOCATION = {
  parish: null,
  city: null,
  state: 'Louisiana',
  zipCode: null,
  allowGeolocation: false,
  locationSet: false
};

export const CONSENT_CATEGORIES = [
  {
    id: 'necessary',
    name: 'Strictly Necessary',
    icon: Shield,
    color: 'green',
    required: true,
    description: 'Essential for the website to function properly. These cannot be disabled.',
    examples: ['User authentication', 'Security features', 'Session management', 'Load balancing'],
    cookies: ['session_id', 'csrf_token', 'auth_token']
  },
  {
    id: 'analytics',
    name: 'Analytics & Performance',
    icon: BarChart3,
    color: 'blue',
    required: false,
    description: 'Help us understand how visitors interact with our website to improve user experience.',
    examples: ['Page view tracking', 'Feature usage analytics', 'Error reporting', 'Performance monitoring'],
    cookies: ['_ga', '_gid', 'analytics_session']
  },
  {
    id: 'marketing',
    name: 'Marketing & Advertising',
    icon: Target,
    color: 'purple',
    required: false,
    description: 'Used to deliver relevant ads and track ad campaign performance.',
    examples: ['Targeted advertising', 'Ad conversion tracking', 'Remarketing', 'Social media ads'],
    cookies: ['_fbp', '_gcl_au', 'ads_session']
  },
  {
    id: 'personalization',
    name: 'Personalization',
    icon: Settings,
    color: 'amber',
    required: false,
    description: 'Allow us to remember your preferences and customize your experience.',
    examples: ['Language preferences', 'Theme settings', 'Dashboard layout', 'Content recommendations'],
    cookies: ['user_preferences', 'theme', 'language']
  },
  {
    id: 'thirdParty',
    name: 'Third-Party Services',
    icon: ExternalLink,
    color: 'rose',
    required: false,
    description: 'Enable integrations with external services that enhance functionality.',
    examples: ['Social media embeds', 'Video players', 'Payment processors', 'Map services'],
    cookies: ['stripe_mid', 'youtube_preferences', 'instagram_embed']
  }
];

export const CONSENT_STORAGE_KEY = 'dowurk_privacy_consent_v2';
export const LOCATION_STORAGE_KEY = 'dowurk_location_preferences';
